import { render, staticRenderFns } from "./ViewResponsability.vue?vue&type=template&id=09cbfc1e&"
import script from "./ViewResponsability.vue?vue&type=script&lang=js&"
export * from "./ViewResponsability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports